<template>
  <div class="compliance__details">
    <div class="compliance__details__label">Document Type</div>
    <div class="compliance__details__value">
      {{ compliance.documentTypeName }}
    </div>
    <div class="compliance__details__label">Document Valid From</div>
    <div class="compliance__details__value">
      {{ compliance.documentValidFromDate | baseDate }}
    </div>
    <div class="compliance__details__label">Document Valid Until</div>
    <div class="compliance__details__value">
      {{ compliance.documentValidToDate | baseDate }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     *  Compliance object
     * @example
     * {
     *  label: String
     *  checked: Boolean
     * }
     */
    compliance: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
